module.exports = __webpack_public_path__ + "img/extended.7fd451a5.png";